import { ReactNode } from 'react';

import Card from '@mui/material/Card';
import { useTheme, type SxProps, type Theme } from '@mui/material/styles';

interface SharedCardProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SharedCard({ children, sx }: SharedCardProps) {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        flex: '0 0 auto',
        minHeight: 0,
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 1,
        border: '0.5px solid',
        borderColor: theme.palette.semantic.outline.light,
        backgroundColor: theme.palette.semantic.surface.bg1,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
